import { render, staticRenderFns } from "./InspectionReportPreview.vue?vue&type=template&id=bef45ffc"
import script from "./InspectionReportPreview.vue?vue&type=script&lang=js"
export * from "./InspectionReportPreview.vue?vue&type=script&lang=js"
import style0 from "./InspectionReportPreview.vue?vue&type=style&index=0&id=bef45ffc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports